const APP_PATH: string = '/app/';

export default APP_PATH;
